import React from 'react';
import format from 'date-fns/fp/format';

const formatDate = format('MMM d, y');

export default ({ value }) => {
  return <div>{value ? formatDate(new Date(value.replaceAll('-', '/'))) : ''}</div>;
};
